
<button mat-menu-item
  title="Delete Harvest"
  [disabled]="deleteHarvestClick"
  (click)="deleteHarvest()">
  @if (deleteHarvestClick) {
    <i class="fa fa-spinner fa-spin"></i>
  }
  <mat-icon aria-hidden="false" aria-label="Delete Harvest">delete</mat-icon>
  <span>Delete Harvest</span>
</button>
